type Value = Nullable<string>;
export function useLocalStorage(key: string, initialValue: Value) {
    return {
        get: () =>
            isLocalStorageSupported()
                ? window.localStorage.getItem(key)
                : initialValue,
        set: (value: Value) => {
            if (isLocalStorageSupported()) {
                if (value == null) {
                    window.localStorage.removeItem(key);
                } else {
                    window.localStorage.setItem(key, value);
                }
            }
        },
    };
}

const isLocalStorageSupported = () =>
    typeof window !== "undefined" && typeof window.localStorage !== "undefined";
